<ng-container>
  <section>
    <mat-tab-group>
      <mat-tab label="Rules Engine" class="mt-2">
        <div class="lookupSection white-bg">
          <section class="mb-3">
            <p class="tabl-header">Validate Existing Data</p>
            <div class="row ">
              <div class="col-md-3 col-sm-6 col-lg-3 col-xl-3 col-xs-3 alignDropdown">
                <mat-form-field appearance="outline" class="dropdownWidth">
                  <mat-label>Select Table</mat-label>
                  <mat-select
                    panelClass="global-select-panel"
                    (keydown)="$event.stopPropagation()"
                    [(ngModel)]="selectedTable"
                    (selectionChange)="tableNameChange()"
                  >
                    <div class="table-data-font">
                      @for (data of tableList; track data) {
                      <mat-option class="global-mat-option" title="{{ data }}" [value]="data">
                        <label style="margin:0%">{{ data }}</label>
                      </mat-option>
                      }
                    </div>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- need validate button -->
              <div class="col-md-3 col-sm-6 col-lg-3 col-xl-3 col-xs-3">
                <button
                  mat-raised-button
                  class="btn uitk-c-button--default techops-global-button validate-button"
                  [disabled]="disableValidateBtn"
                  (click)="validateData()"
                >
                  VALIDATE
                </button>
              </div>
            </div>
          </section>
          <section>
            <p class="tabl-header">Rule Details</p>
            <app-maintenance-table-v4
              [TABLE_CONFIG]="TABLE_CONFIG"
              [COLUMNS]="rule_col"
              [dataSource]="rule_dataSource"
              [pageSize]="TABLE_CONFIG.pageSize"
            >
            </app-maintenance-table-v4>
          </section>
        </div>
      </mat-tab>
    </mat-tab-group>
  </section>
</ng-container>
<!-- <ng-container *ngIf="!rulesEngineVisibility">
<div class="unauthorized-container">
  <div>
    <div class="errorTitle-search"> Unauthorized to view this page. Please contact Techops team.</div>
  </div>
</div>
</ng-container> -->
